import { render, staticRenderFns } from "./BrandCarousel.vue?vue&type=template&id=87ba0800&"
import script from "./BrandCarousel.vue?vue&type=script&lang=js&"
export * from "./BrandCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports